module.exports = __webpack_public_path__ + "static/media/6.bfa7339a.webp";